import * as ents from '@attain-apps/entities'
import * as graphql from '@attain-apps/fe/web/main/lib/graphql'
import * as transformers from '@attain-apps/transformers'
import { TypeChecker } from '@attain-apps/type-guards'
import gql from 'graphql-tag'

import * as attribute from './attribute'

export const DOC = gql`
  ${attribute.DOC}
  fragment FragmentDmsEntity on DmsEntity {
    id
    name
    description
    note
    terms {
      id
    }
    level
    parent {
      id
      name
      description
    }
    child {
      id
      name
      description
    }
    attributes {
      ...FragmentDmsAttribute
    }
  }
`

/**
 * Transformer for the {@link graphql.schema.FragmentDmsEntityFragment} to the
 * {@link ents.core.dms.models.Entity}.
 */
export const TRANSFORMER = graphql.transformers.OUT.object<
  graphql.schema.FragmentDmsEntityFragment,
  ents.core.dms.models.Entity
>({
  attributes: graphql.transformers.OUT.list(attribute.TRANSFORMER, {
    onNullish: 'remove',
  }),
  description: transformers.PASS_THROUGH,
  id: graphql.transformers.OUT.validate(
    transformers.PASS_THROUGH,
    ents.core.dms.models.Entity.Id.isId,
    { warnOnly: true },
  ),
  level: graphql.transformers.OUT.validate(
    transformers.PASS_THROUGH,
    TypeChecker.isNotNullish,
    { warnOnly: true },
  ),
  name: graphql.transformers.OUT.validate(
    transformers.PASS_THROUGH,
    TypeChecker.isNotNullish,
    { warnOnly: true },
  ),
  note: transformers.PASS_THROUGH,
  // TODO: finish implementing
  terms: () => undefined,
})
